/** Non-customer roles resolved by phone for login and enquiry flows. */
export const PROFILE_PHONE_LOOKUP_STAFF_ROLES = [
  'super_admin',
  'admin',
  'manager',
  'supervisor',
  'employee',
  'cleaner',
  'driver',
  'staff',
] as const;
